import {
    LOAD_CRON_JOB_BY_TIME_SUCCESS
} from '../../actions/types';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case LOAD_CRON_JOB_BY_TIME_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/systemControl/ManualActionsReducers.js